import { Component, Input } from '@angular/core';

import { Comment } from '@shared/models/icommons.model';

@Component({
  // tslint:disable-next-line
  selector: '[miq-entry-comment]',
  template: `
    <div class="comment" [ngClass]="{ 'other flt-left': !comment.itsMe, 'mines flt-right': comment.itsMe }">
      <p>{{ comment.message }}</p>
      <div>{{ comment.createBy }}</div>
      <div>{{ comment.createTs | date: 'medium' }}</div>
    </div>
  `,
  styleUrls: ['./entry-comment.component.scss'],
  standalone: false,
})
export class EntryCommentComponent {
  @Input() comment: Comment;
  @Input() self = false;
}
